import React from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "@phosphor-icons/react";

const HERO_IMG = "https://customer-assets.emergentagent.com/job_mobile-detail-hub-3/artifacts/6w3i44z3_7981caaa-5953-4031-8f08-769047dea000.jpeg";

export default function Hero() {
  return (
    <section id="top" data-testid="hero-section" className="relative min-h-[92vh] flex items-end overflow-hidden">
      <div className="absolute inset-0">
        <img src={HERO_IMG} alt="Premium Porsche detail" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-[#050505]/70 to-[#050505]/30" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#050505]/80 via-transparent to-transparent" />
        <div className="grain" />
      </div>

      <div className="container-pd relative z-10 pb-24 pt-40 w-full">
        <div className="max-w-4xl">
          <motion.div
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="flex items-center gap-3 mb-6"
          >
            <div className="divider-gold" />
            <span className="eyebrow">Mobile Car Detailing · Perth, WA</span>
          </motion.div>

          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.05 }}
            className="font-display font-black text-white text-4xl sm:text-5xl lg:text-6xl xl:text-7xl leading-[1.02] tracking-tighter"
          >
            Unapologetic Precision
            <br />
            for <span className="text-[#D4AF37]">Premium Machines.</span>
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.15 }}
            className="mt-8 text-lg sm:text-xl text-zinc-300 max-w-2xl leading-relaxed"
          >
            Mobile detailing for owners who treat their cars as more than transport.
            Surgical attention, premium products, delivered to your driveway in Perth.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.25 }}
            className="mt-10 flex flex-col sm:flex-row gap-4"
          >
            <a href="#quote" data-testid="hero-quote-btn" className="btn-primary">
              Get a Quote <ArrowRight size={16} weight="bold" />
            </a>
            <a href="#quote" data-testid="hero-book-btn" className="btn-secondary">
              Book Now
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
